import React, { useState } from 'react';
import { useNarrative } from '../narrative/NarrativeProvider';
import './Walkthrough.css';

const Walkthrough = () => {
  const { walkthroughs } = useNarrative();
  const [step, setStep] = useState(0);
  const [isOpen, setIsOpen] = useState(true);

  const handleNext = () => {
    if (step < walkthroughs.length - 1) {
      setStep(step + 1);
    } else {
      handleClose();
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem('walkthroughCompleted', 'true');
  };

  if (!isOpen || localStorage.getItem('walkthroughCompleted') === 'true') {
    return null;
  }

  const currentStep = walkthroughs[step];

  return (
    <div className="walkthrough-overlay">
      <div className="walkthrough-panel">
        <h2>{currentStep.title}</h2>
        <p>{currentStep.text}</p>
        <p><em>{currentStep.not}</em></p>
        <button onClick={handleNext}>
          {step < walkthroughs.length - 1 ? 'Next' : 'Finish'}
        </button>
        <button className="close-button" onClick={handleClose}>Skip</button>
      </div>
    </div>
  );
};

export default Walkthrough;
